import { render, staticRenderFns } from "./gLayoutHeader.vue?vue&type=template&id=48cf0445&"
import script from "./gLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./gLayoutHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gLayoutHeader.vue"
export default component.exports